import { Box, List, ListItemButton, ListSubheader } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const DrawerContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  height: '100%',
  padding: theme.spacing(3, 3, 4),
  paddingBottom: `calc(${theme.spacing(4)} + env(safe-area-inset-bottom))`,
  background:
    theme.palette.mode === 'dark'
      ? theme.palette.background.default
      : `linear-gradient(180deg, #ffffff 0%, ${alpha(theme.palette.primary.light, 0.04)} 100%)`,
}));

export const StyledList = styled(List)(({ theme }) => ({
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  backgroundColor: 'transparent',
}));

export const StyledListSubheader = styled(ListSubheader)(({ theme }) => ({
  position: 'relative',
  padding: 0,
  marginBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  fontWeight: 600,
  // デフォルトはデスクトップサイズ、モバイル時（lg未満）は20%小さく
  fontSize: '0.75rem',
  [theme.breakpoints.down('lg')]: {
    fontSize: '0.6rem',
  },
  backgroundColor: 'transparent',
}));

export const StyledListItem = styled(ListItemButton)(({ theme }) => {
  const isDark = theme.palette.mode === 'dark';
  const accent = theme.palette.primary.main;
  const hoverBackground = alpha(accent, isDark ? 0.2 : 0.12);
  const hoverGlow = alpha(accent, isDark ? 0.45 : 0.3);

  return {
    backgroundColor: 'transparent !important',
    boxShadow: 'none',
    borderRadius: typeof theme.shape.borderRadius === 'number' ? theme.shape.borderRadius * 2 : 16,
    padding: theme.spacing(1.25, 2),
    transition: theme.transitions.create(
      ['background-color', 'transform', 'box-shadow', 'filter'],
      {
        duration: theme.transitions.duration.shorter,
      }
    ),
    '& .MuiListItemText-primary': {
      // デフォルトはデスクトップサイズ、モバイル時（lg未満）は20%小さく
      fontSize: '1rem',
      [theme.breakpoints.down('lg')]: {
        fontSize: '0.8rem',
      },
      transition: theme.transitions.create(['color', 'text-shadow'], {
        duration: theme.transitions.duration.shorter,
      }),
    },
    '&:hover': {
      backgroundColor: hoverBackground,
      transform: 'translateY(-1px)',
      boxShadow: `0 0 22px ${hoverGlow} !important`,
      filter: 'saturate(1.05)',
      '& .MuiListItemText-primary': {
        color: isDark ? alpha('#ffffff', 0.92) : theme.palette.primary.main,
        textShadow: `0 0 12px ${hoverGlow}`,
      },
    },
    '&:not(.Mui-selected)': {
      backgroundColor: 'transparent !important',
      boxShadow: 'none',
    },
    '&.Mui-selected': {
      backgroundColor: alpha(theme.palette.primary.main, isDark ? 0.2 : 0.16),
      boxShadow: isDark
        ? `0 10px 24px ${alpha(theme.palette.primary.main, 0.3)}`
        : `0 12px 26px ${alpha(theme.palette.primary.main, 0.22)}`,
      '& .MuiListItemText-primary': {
        color: theme.palette.primary.main,
        textShadow: `0 0 10px ${alpha(theme.palette.primary.main, 0.4)}`,
      },
    },
    '&.Mui-focusVisible': {
      backgroundColor: hoverBackground,
      boxShadow: `0 0 22px ${hoverGlow} !important`,
    },
  };
});

export const MENU_ITEM_TYPOGRAPHY_PROPS = {
  color: 'text.primary',
  fontWeight: 700,
  component: 'span' as const,
};
